import { FC } from 'react';

import { GridColumn, GridRow } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import DetailChart from 'src/pages/Profession/components/SectionStatistics/DetailChart';
import EmptyStateSnack from 'src/pages/Profession/components/SectionStatistics/EmptyStatisticsSnack';
import SalariesChart from 'src/pages/Profession/components/SectionStatistics/SalariesChart';
import Vacancies from 'src/pages/Profession/components/SectionStatistics/Vacancies';
import VacanciesChart from 'src/pages/Profession/components/SectionStatistics/VacanciesChart';

import styles from './styles.less';

const StatisticSection: FC = () => {
    const { currentGrade, currentRegion } = useSelectorNonNullable((state) => state.pageProfession);

    if (!currentGrade) {
        return null;
    }

    // Небольшая хитрость, чтобы переинициализировать графики после смены грейда и региона
    // Если не менять key, то после переключения грейда или региона вперед-назад, состояние в графиках
    // будет актуальным, но будет не корректно отображено начальное состояние графика
    const chartKey = `${currentGrade.id}-${currentRegion}`;

    return (
        <section className={styles.container}>
            <GridRow>
                <GridColumn xs={4} s={8} m={12}>
                    <DetailChart />
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn xs={4} s={8} m={6} flexibleContent>
                    <SalariesChart key={chartKey} />
                </GridColumn>
                <GridColumn xs={4} s={8} m={6} flexibleContent>
                    <div className={styles.vacanciesChart}>
                        <VacanciesChart key={chartKey} />
                    </div>
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn xs={4} s={8} m={12}>
                    <Vacancies />
                </GridColumn>
            </GridRow>
            <EmptyStateSnack />
        </section>
    );
};

export default StatisticSection;
